import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gallery" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_container = _resolveComponent("swiper-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper_container, {
      class: "gallerySwiper",
      navigation: "true",
      pagination: "true",
      autoHeight: "true",
      "slides-per-view": "auto",
      "centered-slides": "true",
      "space-between": "30",
      ref: "swiperContainer"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (item, i) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            class: "gallerySwiperSlide",
            key: i,
            onClick: ($event: any) => (_ctx.openFullImage(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.publicUrl
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}